import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const team = [{
  name: 'Dra. Paula García',
  specialty: 'Médica Especialista en Medicina Estética',
  bio: 'Egresada de la Universidad de la República. Apasionada por la armonización facial y los resultados naturales y duraderos.',
  image: 'https://cdn.magicpatterns.com/uploads/ky3xmnw8FFkSk5NbShJodr/👩_⚕️_Dra._Paula_Garcia_-_Medicina_Estetica_✨Hola_a_todos,_soy_la_Dra._Paula_Garcia._En_el_ano_2.jpg'
}, {
  name: 'Dra. Romina Donate',
  specialty: 'Médica Especialista en Medicina Estética',
  bio: 'Egresada de la Universidad de la República. Especializada en calidad de piel y medicina regenerativa con un enfoque personalizado.',
  image: 'https://cdn.magicpatterns.com/uploads/bdkHWFj3hdgfpGSEG19Zig/👩_⚕️_Dra._Romina_Donate_-_Medica_Estetica_✨Soy_la_Dra._Romina_Donate,_me_gradue_de_medica_en_el.jpg'
}];
export function Team() {
  return <section className="py-24 bg-white" data-id="element-147">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-148">
        <div className="text-center mb-16" data-id="element-149">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-4xl text-charcoal" data-id="element-150">
            Las médicas detrás de Mantra
          </motion.h2>
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-12 md:gap-20" data-id="element-151">
          {team.map((doc, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="max-w-sm text-center group" data-id="element-152">
              <div className="mb-6 overflow-hidden rounded-[2rem] aspect-[4/5] relative" data-id="element-153">
                <div className="absolute inset-0 bg-rosegold/10 mix-blend-overlay z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-154"></div>
                <img src={doc.image} alt={doc.name} className="w-full h-full object-cover object-top grayscale-[20%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" data-id="element-155" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-charcoal mb-1" data-id="element-156">
                {doc.name}
              </h3>
              <p className="text-rosegold font-medium text-sm mb-4" data-id="element-157">
                {doc.specialty}
              </p>
              <p className="text-charcoal/70 mb-6 leading-relaxed" data-id="element-158">{doc.bio}</p>
              <a href="#" className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-ivory text-charcoal hover:bg-rosegold hover:text-white transition-colors" data-id="element-159">
                <Instagram size={18} data-id="element-160" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}